import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Category } from 'src/app/entities/category';
import { CategoryService } from 'src/app/services/category.service';
import { BaseAddComponent } from '../base-add/base-add.component';
import { AlertService } from 'src/app/services/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { fuseAnimations } from '@mobileia/layout-fuse';
import { GoogleStorageService } from 'src/app/services/google-storage.service';

@Component({
  selector: 'app-category-add',
  templateUrl: './category-add.component.html',
  styleUrls: ['./category-add.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class CategoryAddComponent extends BaseAddComponent<Category> implements OnInit {

  pathUrlList = 'category';
  categoriesParents = new Array<Category>();

  constructor(
    protected categoryService: CategoryService,
    protected alertService: AlertService,
    protected filesService: GoogleStorageService,
    protected route: ActivatedRoute,
    protected navigator: Router
  ) {
    super(alertService, route, navigator);
    this.service = categoryService;
    this.serviceGoogle = filesService;
    this.item = new Category();
    this.initFields();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.loadParents();
  }

  initFields() {
    this.configFields = [
      {
        type: 'string',
        key: 'title',
        title: 'Titulo',
        caption: ''
      },
      {
        type: 'file',
        key: 'photo',
        fileType: 'path',
        title: 'URL de la imagen',
        caption: 'Recomendado: imagen cuadrada PNG con fondo transparente, aprox. 600x600px.'
      },
      {
        type: 'select',
        key: 'parent_id',
        title: 'Categoría Padre',
        caption: '',
        options: []
      },
      {
        type: 'select',
        key: 'is_feature',
        title: '¿Destacada?',
        caption: '',
        options: [
          {
            title: 'SI',
            value: 1
          },
          {
            title: 'NO',
            value: 0
          }
        ]
      },
      {
        type: 'select',
        key: 'status',
        title: 'Estado',
        caption: '',
        options: [
          {
            title: 'Activa',
            value: 1
          },
          {
            title: 'Inactiva',
            value: 0
          }
        ]
      }
    ];
  }

  processParents() {
    let options = [];
    for (const parent of this.categoriesParents) {
      options.push({
        title: parent.title,
        value: parseInt(parent.id)
      });
    }
    this.configFields[2].options = options;
  }

  loadParents() {
    this.categoryService.fetchAll().toPromise().then(data => {
      if (!data.success) {
        return;
      }
      this.categoriesParents = data.response.data;
      this.processParents();
    });
  }
}
